module.exports = __webpack_public_path__ + "img/box4.55e0f38a.png";